import classNames from 'classnames'
import styles from './Spinner.module.css'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: styles['sm'],
  md: styles['md'],
  lg: styles['lg'],
}

export function Spinner({ size = 'md' }: SpinnerProps) {
  return (
    <div
      className={classNames(styles['spinner'], sizeClasses[size])}
      role="status"
      aria-label="Loading"
    />
  )
}
